export const GET_DONATION_INFO_LOADING = 'REDUX_SAGA_GET_DONATION_INFO_LOADING';
export const DONATION_DATA_SUCCESS = 'REDUX_SAGA_DONATION_DATA_SUCCESS';
export const DONATION_DATA_ERROR = 'REDUX_SAGA_DONATION_DATA_ERROR';
export const DONATION_DATA_RESET = 'REDUX_SAGA_DONATION_DATA_RESET';

export const actionGetDonation = (dispatch, productId, productType) => {
    dispatch({
        type: GET_DONATION_INFO_LOADING,
        payload: { productId: productId, productType: productType }
    })
};


export const actionResetDonations = (dispatch) => {
    dispatch({ type: DONATION_DATA_RESET })
};